import React from "react";
import CardSimple from "../../../../components/basic/CardSimple";

const MeasurementSettings = () => {
  return (
    <CardSimple>
      <div id="create-measurement">
        <br />
        <div>
          <div className="support-wrapper support-manual">
            <h2>Create Measurement</h2>
            <ul>
              <li>Go to Menu > Pricing > Measurement Settings</li>
              <img src={require("./SupportDocImages/measurement_setting_images/measurement_setting.PNG")} />
              <li>Click on 'Add New Measurement Setting'</li>
              <img
                src="http://techpos.ca/support-images/MeasurementSetting/create/Measure-2.png"
                width="600"
              />
              <li>Fill out the name and units in grams</li>
              <img src="http://techpos.ca/support-images/MeasurementSetting/create/Measure-3.png" />

              <li>Click on Save</li>
              <img src="http://techpos.ca/support-images/MeasurementSetting/create/Measure-4.png" />
            </ul>
          </div>
        </div>
        <div id="edit-measurement">
          <br />
          <hr />
          <div className="support-wrapper support-manual">
            <h2>Edit Measurement</h2>
            <ul>
              <li>Go to Menu > Pricing > Measurement Settings</li>
              <img src={require("./SupportDocImages/measurement_setting_images/measurement_setting.PNG")} />
              <li>Click on the Edit button</li>
              <img src="http://techpos.ca/support-images/MeasurementSetting/edit/MeasureEdit-2.png" />
              <li>Make any changes you would like and then click Save</li>
            </ul>
          </div>
        </div>
      </div>
    </CardSimple>
  );
};

export default MeasurementSettings;
